import PropTypes from 'prop-types';
export const sliceStatusPropTypes = PropTypes.oneOf(['idle', 'loading', 'succeeded', 'failed', 'init']);
export const sliceErrorsPropTypes = PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string }));
export const baseSlicePropTypes = PropTypes.shape({
    status: sliceStatusPropTypes,
    errors: sliceErrorsPropTypes
});
